import { isServer } from 'tradera-utils/nextjs';

export default !isServer && window.sellingGlobalData;
